import { inject, Injectable } from '@angular/core';
import { AuthStoreService } from 'shared';
import type { BcfFormat } from './export-bcf-dialog.component';

const BCF_EXPORT_FORMAT_KEY = 'ocp.tasks.export-bcf.format';

function bcfExportFormatKey(userSub: string): string {
  return `${BCF_EXPORT_FORMAT_KEY}.${userSub}`;
}

@Injectable({ providedIn: 'root' })
export class BcfExportPreferenceService {
  private readonly authStore = inject(AuthStoreService);

  getLastUsedFormat(): BcfFormat | null {
    const userSub = this.authStore.userSub();
    if (!userSub) return null;

    try {
      const value = localStorage.getItem(bcfExportFormatKey(userSub));
      return value === '2.1' || value === '3.0' ? value : null;
    } catch {
      return null;
    }
  }

  setLastUsedFormat(format: BcfFormat): void {
    const userSub = this.authStore.userSub();
    if (!userSub) return;

    try {
      localStorage.setItem(bcfExportFormatKey(userSub), format);
    } catch {
      // storage unavailable (e.g. blocked in embedded/iframe context)
    }
  }
}
